module.exports = __webpack_public_path__ + "static/media/nail-nyc.bb5020d5.jpg";